// extracted by mini-css-extract-plugin
module.exports = {"header":"StatsCard_header__2Rsh9","item":"StatsCard_item__o_aVl","icon":"StatsCard_icon__3KK1b"};